import React from 'react';
import { Tabs } from 'antd';
import { iconComponents, TAB_CONFIGS } from '../configs/visualConfig';
import OverviewTab from './OverviewTab';
import FloorPlanTab from './FloorPlanTab';
import ThreeDTab from './ThreeDTab';
import MapTab from './MapTab';

interface SpaceVisualTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  selectedFloor?: string;
  setSelectedFloor: (floor: string) => void;
  handleRefresh: () => void;
  handleFullscreen: () => void;
  handleSettings: () => void;
}

const SpaceVisualTabs: React.FC<SpaceVisualTabsProps> = ({
  activeTab,
  setActiveTab,
  selectedFloor,
  setSelectedFloor,
  handleRefresh,
  handleFullscreen,
  handleSettings
}) => {
  // 创建标签页配置
  const tabConfigs = [
    TAB_CONFIGS.OVERVIEW,
    TAB_CONFIGS.FLOOR_PLAN,
    TAB_CONFIGS.THREE_D,
    TAB_CONFIGS.MAP
  ];

  // 转换为 Ant Design Tabs 需要的格式
  const tabItems = tabConfigs.map((config) => {
    const IconComponent = iconComponents[config.icon];
    const icon = <IconComponent />;

    let children: React.ReactNode = null;

    // 为特定标签页设置内容
    if (config.key === TAB_CONFIGS.OVERVIEW.key) {
      children = (
        <OverviewTab
          selectedFloor={selectedFloor}
          onFloorChange={setSelectedFloor}
          onRefresh={handleRefresh}
          onFullscreen={handleFullscreen}
          onSettings={handleSettings}
        />
      );
    } else if (config.key === TAB_CONFIGS.FLOOR_PLAN.key) {
      children = (
        <FloorPlanTab
          selectedFloor={selectedFloor}
          onFloorChange={setSelectedFloor}
          onRefresh={handleRefresh}
          onFullscreen={handleFullscreen}
          onSettings={handleSettings}
        />
      );
    } else if (config.key === TAB_CONFIGS.THREE_D.key) {
      children = (
        <ThreeDTab
          selectedFloor={selectedFloor}
          onFloorChange={setSelectedFloor}
          onRefresh={handleRefresh}
          onFullscreen={handleFullscreen}
          onSettings={handleSettings}
        />
      );
    } else if (config.key === TAB_CONFIGS.MAP.key) {
      children = (
        <MapTab
          selectedFloor={selectedFloor}
          onFloorChange={setSelectedFloor}
          onRefresh={handleRefresh}
          onFullscreen={handleFullscreen}
          onSettings={handleSettings}
        />
      );
    }

    return {
      key: config.key,
      label: (
        <span>
          {icon}
          {config.label}
        </span>
      ),
      children
    };
  });

  return (
    <Tabs
      activeKey={activeTab}
      onChange={setActiveTab}
      items={tabItems}
      size="large"
    />
  );
};

export default SpaceVisualTabs;
